import axios from 'axios';
import { API_CONFIG } from '../config/api';

function addAuthInterceptors(instance) {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const token = localStorage.getItem('token');
        if (token) {
          // Only redirect if user had an active session (token expired/invalid)
          localStorage.removeItem('token');
          window.location.href = '/';
        }
      }
      return Promise.reject(error);
    }
  );
}

// Apply to the global axios instance — covers every raw axios.post/get call
addAuthInterceptors(axios);

// Named instance used by chatService etc.
const apiClient = axios.create(API_CONFIG);
addAuthInterceptors(apiClient);

export default apiClient;
